define.alias("shared/utils/insert-text-at-cursor", "calendar/utils/insert-text-at-cursor");